import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import {
  components as largeRoom100HzComponent,
  extraContent as largeRoom100HzExtraContent,
} from "./components/large-room-100hz";
import {
  components as largeRoom1kHzComponent,
  extraContent as largeRoom1kHzExtraContent,
} from "./components/large-room-1khz";
import {
  components as largeRoom500HzComponent,
  extraContent as largeRoom500HzExtraContent,
} from "./components/large-room-500hz";
import {
  components as largeRoom50HzComponent,
  extraContent as largeRoom50HzExtraContent,
} from "./components/large-room-50hz";
import {
  components as largeRoom5kHzComponent,
  extraContent as largeRoom5kHzExtraContent,
} from "./components/large-room-5khz";
import {
  components as smallRoom100HzComponent,
  extraContent as smallRoom100HzExtraContent,
} from "./components/small-room-100hz";
import {
  components as smallRoom1kHzComponent,
  extraContent as smallRoom1kHzExtraContent,
} from "./components/small-room-1khz";
import {
  components as smallRoom500HzComponent,
  extraContent as smallRoom500HzExtraContent,
} from "./components/small-room-500hz";
import {
  components as smallRoom50HzComponent,
  extraContent as smallRoom50HzExtraContent,
} from "./components/small-room-50hz";
import {
  components as smallRoom5kHzComponent,
  extraContent as smallRoom5kHzExtraContent,
} from "./components/small-room-5khz";

const principle: Slide = {
  title: "",
  description:
    "Geometrical acoustics is a simple way to efficiently model the sound propagation in rooms. Due to the plane wave assumption, the error of the simulated sound pressure, however, increases if the sound source and/or receiver are located close to the room’s boundaries. In this example, the error for two different room dimensions is qualitatively visualized.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "small room" }, { name: "large room" }],
        },
        {
          type: "button",
          options: {},
          items: [{ name: "50 Hz" }, { name: "100 Hz" }, { name: "500 Hz" }, { name: "1 kHz" }, { name: "5 kHz" }],
        },
      ],
      extraContent: [
        [
          smallRoom50HzExtraContent,
          smallRoom100HzExtraContent,
          smallRoom500HzExtraContent,
          smallRoom1kHzExtraContent,
          smallRoom5kHzExtraContent,
        ],
        [
          largeRoom50HzExtraContent,
          largeRoom100HzExtraContent,
          largeRoom500HzExtraContent,
          largeRoom1kHzExtraContent,
          largeRoom5kHzExtraContent,
        ],
      ],
      components: [
        [
          smallRoom50HzComponent,
          smallRoom100HzComponent,
          smallRoom500HzComponent,
          smallRoom1kHzComponent,
          smallRoom5kHzComponent,
        ],
        [
          largeRoom50HzComponent,
          largeRoom100HzComponent,
          largeRoom500HzComponent,
          largeRoom1kHzComponent,
          largeRoom5kHzComponent,
        ],
      ],
    },
  },
};

export default principle;
